import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

// Router
import { BrowserRouter } from "react-router-dom"

// contexts
import DeviceMetricsProvider from "./contexts/DeviceMetricsContext"
import RTCProvider from "./contexts/RTCContext"
import AppProvider from "./contexts/AppContext"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
	<BrowserRouter>
		<AppProvider>
			<RTCProvider>
				<DeviceMetricsProvider>
					<App />
				</DeviceMetricsProvider>
			</RTCProvider>
		</AppProvider>
	</BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
